import { useCallback, useState } from 'react';
export function useListKeyboardNavigation(listSize, onItemSelected, onCloseList, initialSelectedItemIndex = -1) {
    const [selectedIndex, setSelectedIndex] = useState(initialSelectedItemIndex);
    const onKeyEvent = useCallback((e)=>{
        switch(e.key){
            case 'ArrowUp':
                setSelectedIndex((index)=>Math.max(index - 1, 0));
                e.preventDefault();
                e.stopPropagation();
                return;
            case 'ArrowDown':
                setSelectedIndex((index)=>Math.min(index + 1, listSize - 1));
                e.preventDefault();
                e.stopPropagation();
                return;
            case 'Home':
                setSelectedIndex(0);
                e.preventDefault();
                return;
            case 'End':
                setSelectedIndex(listSize - 1);
                e.preventDefault();
                return;
            case 'Enter':
                onItemSelected && onItemSelected(selectedIndex);
                e.preventDefault();
                return;
            case 'Escape':
                onCloseList && onCloseList();
                e.preventDefault();
                e.stopPropagation();
                return;
            default:
        }
    }, [
        listSize,
        onCloseList,
        onItemSelected,
        selectedIndex
    ]);
    const resetSelectedIndex = useCallback(()=>{
        setSelectedIndex(-1);
    }, []);
    const selectFirstIndex = useCallback(()=>listSize > 0 ? setSelectedIndex(0) : resetSelectedIndex(), [
        resetSelectedIndex,
        listSize
    ]);
    return {
        /**
     * Handles a key event and applies the appropriate transformation to the `selectedIndex`.
     *
     * Add this to your containing element's `onKeyDown` event handler.
     */ onKeyEvent,
        /** The selected index. Starts out at -1 to indicate nothing is selected. */ selectedIndex,
        /**
     * Resets the selected index to its initial value (-1). We need this is circumstances where the list of items may change.
     *
     * e.g. A search field that updates the list when it's changed. Once the loading state is shown, we should call `resetSelectedIndex`
     */ resetSelectedIndex,
        /**
     * Selects the first index in the list if the list has elements. Resets the selected index to -1 if not.
     */ selectFirstIndex
    };
}
